import { useUser } from 'src/providers/UserProvider'

import {
  DeleteApplicationAssetMutationFn,
  DeleteProjectAssetMutationFn,
  DeletePlantingAssetMutationFn,
  DeletePlantingSiteAssetMutationFn,
  DeleteMonitoringAssetMutationFn
} from 'src/config/generated/graphql'

export type RollbackAssetMutationFn =
  | DeleteApplicationAssetMutationFn
  | DeleteProjectAssetMutationFn
  | DeletePlantingAssetMutationFn
  | DeletePlantingSiteAssetMutationFn
  | DeleteMonitoringAssetMutationFn

export const useRollback = (rollbackFn: RollbackAssetMutationFn) => {
  const { user } = useUser()

  return async (id: string) => {
    if (!user?.Account?.PlanterId) {
      return undefined
    }
    return rollbackFn({
      variables: {
        id,
        planterId: user?.Account?.PlanterId
      }
    })
  }
}
